export default {
    name: 'v5-icon-close',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M512 83.2c-234.667 0-426.667 192-426.667 426.667s192 426.666 426.667 426.666 426.667-192 426.667-426.666S746.667 83.2 512 83.2zm0 810.667c-211.2 0-384-172.8-384-384s172.8-384 384-384 384 172.8 384 384c0 213.333-172.8 384-384 384zM674.133 345.6c-8.533-8.533-21.333-8.533-29.866 0L509.867 480l-134.4-134.4c-8.534-8.533-21.334-8.533-29.867 0-8.533 8.533-8.533 21.333 0 29.867l134.4 134.4-134.4 134.4c-8.533 8.533-8.533 21.333 0 29.866 4.267 4.267 10.667 6.4 14.933 6.4 6.4 0 10.667-2.133 14.934-6.4L512 539.733l134.4 134.4c4.267 4.267 10.667 6.4 14.933 6.4 6.4 0 10.667-2.133 14.934-6.4 8.533-8.533 8.533-21.333 0-29.866l-134.4-134.4 134.4-134.4c6.4-8.534 6.4-21.334-2.134-29.867z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
